/**
 * Build styles
 */
import './index.css';
import { IconItalic } from '@codexteam/icons'

export default class Italic {

  static get CSS() {
    return 'cdx-italic';
  };

  constructor({ api }) {
    this.api = api;
    this.button = null;

    this.tag = 'I';

    this.iconClasses = {
      base: this.api.styles.inlineToolButton,
      active: this.api.styles.inlineToolButtonActive,
    };
  }


  static get isInline() {
    return true;
  }

  render() {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add(this.iconClasses.base);
    this.button.innerHTML = this.toolboxIcon;

    return this.button;
  }

  surround(range) {
    if (!range) {
      return;
    }

    const termWrapper = this.api.selection.findParentTag(this.tag, Italic.CSS);

    if (termWrapper) {
      this.unwrap(termWrapper);
    } else {
      this.wrap(range);
    }
  }


  wrap(range) {

    const i = document.createElement(this.tag);

    i.classList.add(Italic.CSS);

    i.appendChild(range.extractContents());
    range.insertNode(i);


    this.api.selection.expandToTag(i);
  }

  unwrap(termWrapper) {

    this.api.selection.expandToTag(termWrapper);

    const sel = window.getSelection();
    const range = sel.getRangeAt(0);

    const unwrappedContent = range.extractContents();

    termWrapper.parentNode.removeChild(termWrapper);

    range.insertNode(unwrappedContent);

    sel.removeAllRanges();
    sel.addRange(range);
  }

  checkState() {
    const termTag = this.api.selection.findParentTag(this.tag, Italic.CSS);

    this.button.classList.toggle(this.iconClasses.active, !!termTag);
  }

  
  get toolboxIcon() {
    return IconItalic;
  }


  static get sanitize() {
    return {
      i: {
        class: Italic.CSS,
      },
    };
  }
}